import moment from 'moment'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import { exportHeader, exportDetailHeader, exportWriteOffDetailHeader, exportWriteOffStatusHeader, exportSearchAggregateheader, defalutValueSummary } from '@views/payment-manager/components/payment-manager-export-header.js'

export default {
  data () {
    return {
      exportHeader,
      exportDetailHeader,
      exportWriteOffDetailHeader,
      exportWriteOffStatusHeader,
      exportSearchAggregateheader,
      defalutValueSummary,
    }
  },
  methods: {
    exportDetailTableData (params) {
      return request.page('exportDetailTableData', params)
    },
    exportWriteOffDetailTableData (params) {
      return request.page('exportWriteOffDetailTableData', params)
    },
    exportWriteOffStatusDataRequest (params) {
      return request.page('exportWriteOffStatusData', params)
    },

    exportExportSearchAggregateData (params) {
      return request.page('exportExportSearchAggregateData', params)
    },

    // 按照财务格式导出
    onExportFinanceSearch () {
      this.$export('付款列表财务格式导出', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.exportTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },

    // 按照付款明细导出
    onExportDetailSearch () {
      this.$export('付款明细导出', {
        fileHeader: this.exportDetailHeader,
        total: this.pagination.total,
        request: this.exportDetailTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          data.data = this.handleExportDetailData(data.data)
          return data
        }
      })
    },

    // 导出预付款冲销明细
    onExportWriteOffSearch () {
      this.$export('预付款冲销明细导出', {
        fileHeader: this.exportWriteOffDetailHeader,
        total: this.pagination.total,
        request: this.exportWriteOffDetailTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          data.data = this.handleExportWriteOffDetailData(data.data)
          return data
        }
      })
    },

    // 导出预付款冲销状态明细
    onExportWriteOffStatus () {
      this.$export('预付款单据冲销状态导出', {
        fileHeader: this.exportWriteOffStatusHeader,
        total: this.pagination.total,
        request: this.exportWriteOffStatusDataRequest,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },

    // 按搜索结果汇总
    onExportSearchAggregate () {
      this.$export('付款汇总', {
        fileHeader: this.exportSearchAggregateheader,
        total: this.pagination.total,
        request: this.exportExportSearchAggregateData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = _.values(data)
          return data
        }
      })
    },


    // 批量下载 pdf zip 文件
    onDownLoadPDFS () {
      let id = this.multipleSelection.map(_ => _.id)
      request.common('exportPaymentApplicationsBatchPdfs', {id}).then((data) => {
        let filename = data.data
        let api = request.items.downloadPdfFileFromServer({filename: filename})
        downloadJS(api, false, false, {
          'SJ-Auth-Token': getToken()
        })
      })
    },

    handleExportData (data) {
      const payType = {...this.type, 4: '批量付款'}
      data.forEach((row) => {
        row.status = this.status[row.status]

        row.applicant_name = row.applicant_name + '/' + row.applicant_real_name
        row.type = payType[row.type]

        row.payment_company = this.paymentCompanys[row.payment_company]
        if (moment(row.expected_date, 'yyyy-MM-dd HH:mm:ss').isValid()) {
          row.expected_date = this.formatExportDate(row.expected_date)
        }
        if (moment(row.paid_date, 'yyyy-MM-dd HH:mm:ss').isValid()) {
          row.paid_date = this.formatExportDate(row.paid_date)
        } else {
          row.paid_date = '无'
        }
      })
      return data
    },
    formatExportDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    handleExportDetailData (data) {
      data.forEach((row) => {
        row.detail_first_subject = this.originFirstSubjects[row.detail_first_subject]
        row.detail_second_subject = this.originSecondSubjects[row.detail_second_subject]
        row.detail_invoice_type = this.invoiceType[row.detail_invoice_type] || '-'
        row.detail_tax_rate = row.detail_tax_rate + '%'
        row.detail_paid_amount = filter.seperateThousandsToFixed(row.detail_paid_amount, 2)
        row.detail_paid_no_tax_amount = filter.seperateThousandsToFixed(row.detail_paid_no_tax_amount, 2)
        row.detail_apply_amount = filter.seperateThousandsToFixed(row.detail_apply_amount, 2)
        if (row.detail_project_id * 1 === 0) {
          row.detail_project_name = row.detail_project_number = '无'
        }
      })
      return data
    },

    handleExportWriteOffDetailData (data) {
      data.forEach((row) => {
        row.detail_write_off_at = this.formatExportDate(row.detail_write_off_at)

        row.detail_first_subject = this.originFirstSubjects[row.detail_first_subject]
        row.detail_second_subject = this.originSecondSubjects[row.detail_second_subject]
        row.detail_invoice_type = this.invoiceType[row.detail_invoice_type] || '-'
        row.detail_tax_rate = row.detail_tax_rate + '%'
        row.detail_amount_with_taxed = filter.seperateThousandsToFixed(row.detail_amount_with_taxed, 2)
        row.detail_amount_untaxed = filter.seperateThousandsToFixed(row.detail_amount_untaxed, 2)
        if (row.detail_project_id * 1 === 0) {
          row.detail_project_name = row.detail_project_number = '无'
        }
      })
      return data
    },
  },

}



// WEBPACK FOOTER //
// ./src/views/payment-manager/payment-info-export.mixins.js